// Newest1 - Start

import { Component } from "react";
// import {getEndPoint,getTokenFromLocStorage, callApi} from  '../../common_utilities/commonjsfunc';
//import axios from 'axios';
import { axiosCustomObj } from "../customisedthirdparty/AxiosCustom";
import { commonJsFuncModule as commonJsObj } from "../../common_utilities/commonjsfunc";

const getTokenFromLocStorage = commonJsObj.getTokenFromLocStorage;
// const getCurrentUserId = commonJsObj.getCurrentUserId;
const getOffsetOfLocalDateTime = commonJsObj.getOffsetOfLocalDateTime;

/**
 * AddProfInfoFetchKYCService
 * Page/Class name   : AddProfInfoFetchKYCService
 * Author            :
 * Created Date      : 7-7-2021
 * Functionality     : constructor, componentDidMount , componentWillUnmount
 * Purpose           : api service page
 **/
class AddProfInfoFetchKYCService extends Component {
  /**
   * AddProfInfoFetchKYCService
   * Function name : constructor
   * Author        :
   * Created Date  : 7-7-2021
   * Purpose       : initializing state
   * Params        :
   **/
  constructor() {
    super();
    this.state = {};

    //this.axiosObj = axios;
    this.axiosObj = null;

    this.fetchKYCApiEndPoint =
      commonJsObj.getEndPoint() + "rest/kyc/lp_profile/";
  }

  /**
   * AddProfInfoFetchKYCService
   * Function name : componentDidMount
   * Author        :
   * Created Date  : 7-7-2021
   * Purpose       : life cycle method
   * Params        :
   **/
  componentDidMount() {}

  /**
   * AddProfInfoFetchKYCService
   * Function name : componentWillUnmount
   * Author        :
   * Created Date  : 7-7-2021
   * Purpose       : life cycle method
   * Params        :
   **/
  componentWillUnmount() {}

  /**
   * AddProfInfoFetchKYCService
   * Function name : fetchKYCDetails
   * Author        :
   * Created Date  : 7-7-2021
   * Purpose       : Service to fetch the KYC details of the Professional with additional profile information
   * Params        : lpUserId
   **/
  async fetchKYCDetails(lpUserId) {
    this.axiosObj = axiosCustomObj({});

    const accToken = getTokenFromLocStorage();
    const offsetOfLocalDateTime = getOffsetOfLocalDateTime(new Date());

    try {
      let urldata = this.fetchKYCApiEndPoint;

      const offsetHr = offsetOfLocalDateTime.hr;
      const offsetMin = offsetOfLocalDateTime.min;

      urldata =
        urldata +
        lpUserId +
        "?offset_hour=" +
        offsetHr +
        "&offset_minute=" +
        offsetMin;

      const headerOptn = {
        "Content-Type": "application/json",
        Authorization: accToken,
      };

      let respObj = this.axiosObj.get(urldata, {
        headers: headerOptn,
      });

      return respObj;
    } catch (err) {
      // console.log("Some error occured===>", err); // TypeError: failed to fetch
    }
  }
}

export default AddProfInfoFetchKYCService;

// Newest1 - End
